import api from '@/api';
import { API_BASE_URL } from '../..';
import {
  PurchaseCfop,
  PurchaseDateSupplierWorkorder,
  PurchaseDocumentType,
  PurchaseReportRequest,
  PurchaseSupplierSynthetic,
} from './PurchasesReport.types';

const BASE_URL = `${API_BASE_URL}/generate`;

export async function getPurchaseCfopData(params: PurchaseReportRequest) {
  const result = (await api.get(
    `${BASE_URL}/purchase-cfop/data`,
    params,
  )) as unknown;
  return result as PurchaseCfop[];
}

export async function getPurchaseDateSupplierWorkorder(
  params: PurchaseReportRequest,
) {
  const result = (await api.get(
    BASE_URL + '/purchase-date-supplier-workorder/data',
    params,
  )) as unknown;
  return result as PurchaseDateSupplierWorkorder[];
}

export async function getPurchaseDocumentType(params: PurchaseReportRequest) {
  const result = (await api.get(
    BASE_URL + '/purchase-document-type/data',
    params,
  )) as unknown;
  return result as PurchaseDocumentType[];
}

export async function getPurchaseSupplierSynthetic(
  params: PurchaseReportRequest,
) {
  const result = (await api.get(
    BASE_URL + '/purchase-supplier-synthetic/data',
    params,
  )) as unknown;
  return result as PurchaseSupplierSynthetic[];
}
